/* eslint-disable react-hooks/exhaustive-deps */
import { Accordion, AccordionTab } from 'primereact/accordion';
import { CheckoutConfirmation } from 'components/CheckoutConfirmation';
import { itemsAreAllVirtual } from 'utils/cartUtils';
import { ReactElement, useEffect, useState } from 'react';
import { useCartContext } from 'CartContext';
import { useNavigate } from 'react-router-dom';
import CheckoutSummary from 'components/CheckoutSummary';
import Footer from 'components/footer-crwd/Footer';
import Nav from 'components/nav/Nav';
import './Checkout.scss';
import ReactGA from 'react-ga4';
import { Head } from './head/Head';

export enum CustomerOption {
  guestCheckout,
  login,
  registerAccount,
}

export default function CheckoutComplete(): ReactElement {
  const checkoutOptionsIndex = 0;
  const accountBillingDetailsIndex = 1;
  const shippingDetailsIndex = 2;
  const paymentIndex = 3;
  const confirmationIndex = 4;

  const navigate = useNavigate();

  const [accordionIndex, setAccordionIndex] = useState(checkoutOptionsIndex);
  const [clickNeedsHandling, setClickNeedsHandling] = useState(false);
  const [newCustomerOption] = useState<number>(CustomerOption.login);
  const [hasConfirmedBilling] = useState(false);
  const [localOrderNumber] = useState<string>();

  const {
    billingAddress,
    items,
    loading,
    shippingAddress,
    userInfo,
    setBillingAddress,
    setOrderNumber,
  } = useCartContext();

  // const ItemObject = items.map(item => ({
  //   name: item.product.name,
  //   id: item.product.sku,
  //   price: Number(item.product.price_range.maximum_price.final_price.value),
  //   brand: item.product.vendor_company,
  //   category: '',
  //   variant: '',
  //   quantity: item.quantity,
  // }));

  // const ItemObjectGA = items.map(item => ({
  //   name: item.product.name,
  //   id: item.product.sku,
  //   revenue: Number(item.product.price_range.maximum_price.final_price.value),
  //   affiliation: item.product.vendor_company,
  //   category: '',
  //   variant: '',
  //   quantity: item.quantity,
  // }));

  const shouldGetShipping = !itemsAreAllVirtual(items);

  useEffect(() => {
    if (userInfo && !billingAddress) {
      setBillingAddress({
        ...userInfo.address,
      });
    }
  }, [userInfo, billingAddress]);

  useEffect(() => {
    if (
      clickNeedsHandling &&
      accordionIndex === checkoutOptionsIndex &&
      (userInfo || newCustomerOption !== CustomerOption.login)
    ) {
      setAccordionIndex(accountBillingDetailsIndex);
      setClickNeedsHandling(false);
    }
  }, [newCustomerOption, userInfo, clickNeedsHandling]);

  useEffect(() => {
    if (
      accordionIndex === accountBillingDetailsIndex &&
      billingAddress &&
      userInfo &&
      hasConfirmedBilling
    ) {
      if (shouldGetShipping) {
        setAccordionIndex(shippingDetailsIndex);
      } else {
        setAccordionIndex(paymentIndex);
      }
    }
  }, [billingAddress, userInfo, hasConfirmedBilling]);

  useEffect(() => {
    if (accordionIndex === shippingDetailsIndex && shippingAddress) {
      setAccordionIndex(paymentIndex);
    }
  }, [shippingAddress]);

  useEffect(() => {
    if (accordionIndex === paymentIndex && localOrderNumber) {
      setAccordionIndex(confirmationIndex);
      setOrderNumber(localOrderNumber);
    }
  }, [localOrderNumber]);

  useEffect(() => {
    if (!items.length && !loading) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    ReactGA.event({
      category: 'ecommerce',
      action: 'checkout_complete',
      label: 'Checkout Complete',
    });
  }, []);

  return (
    <>
      <Nav />
      <Head
        title="Checkout Complete"
        link="/checkout-complete"
        keywords="purchase complete, complete purchase, checkout complete"
        twitterUsername="@advancedmedmkt"
      />
      <div
        className="grid flex justify-content-center mx-auto mt-0 mb-4"
        style={{ maxWidth: '1140px' }}
      >
        <div className="col-12 lg:col-8 flex-order-1 lg:flex-order-0">
          <Accordion
            activeIndex={4}
            onTabChange={e => {
              setAccordionIndex(e.index);
            }}
          >
            <AccordionTab header="Step 1: Checkout Options" disabled />
            <AccordionTab header="Step 2: Account & Billing Details" disabled />
            <AccordionTab header="Step 3: Shipping Details" disabled />
            <AccordionTab header="Step 4: Payment" disabled />
            <AccordionTab header="Step 5: Confirmation" disabled={false}>
              <CheckoutConfirmation />
            </AccordionTab>
          </Accordion>
        </div>
        <CheckoutSummary orderCompleted />
      </div>
      <Footer />
    </>
  );
}
